import React from 'react';
import { List, Grid, Checkbox } from 'antd-mobile';
import './TeamChoice.css';
import PropTypes from 'prop-types';

const TeamChoice = props => {
    return (
        <List renderHeader={props.header} className='ls_choice_team_container'>
            <List.Item multipleLine wrap>
                <Grid 
                    data={props.teams} 
                    columnNum={2} 
                    hasLine={false}
                    square={false}
                    itemStyle={{
                        border: '1px solid #ddd',
                        borderRadius: '5px'
                    }}
                    onClick={el => props.onChange(el.teamId, el.name || el.text, el.category)}
                    renderItem={(el, i) => (
                        <Checkbox 
                            key={i}
                            defaultChecked={parseInt(props.teamName) === parseInt(el.teamId)}
                            checked={parseInt(props.teamName) === parseInt(el.teamId)}
                        >
                            <div className="am-grid-item-inner-content column-num-2 ls_choice_team">
                                <img className="am-grid-icon" src={el.icon} alt='' />
                                <div className="am-grid-text common"  style={{fontSize: '14px', fontWeight: '700'}}>{el.text}</div>
                            </div>
                        </Checkbox>
                    )}
                />
            </List.Item>
        </List>
    )
}

TeamChoice.propTypes = {
    header: PropTypes.func.isRequired,
    teams: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string,
        text: PropTypes.string,
        teamId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })).isRequired,
    teamName: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func.isRequired
}

export default TeamChoice;